import { useState } from 'react';

import useAxios from 'axios-hooks';

import strings, { url } from 'constants/index';
import {
  FixtureRecreateDialog,
  FixtureRecreateFormValues,
} from 'features/fixtures/components/FixtureRecreateDialog/FixtureRecreateDialog';
import { useDialogStatus } from 'hooks/common';
import { getHoursDiff } from 'utils/form.utils';

export const useFixtureRecreation = ({
  fixtureId,
  onFormSubmit,
}: {
  fixtureId: string | number;
  onFormSubmit: (formData: any, recreatingFormValues: FixtureRecreateFormValues) => void;
}) => {
  const { isOpen, onShow, onHide } = useDialogStatus();
  const [message, setMessage] = useState('');

  // fixture config
  const [{ data: config, loading: isConfigLoading }] = useAxios(
    `${url.fixtures}/${fixtureId}/config`,
    { manual: !fixtureId },
  );

  const [{ data: curationPropertiesData }] = useAxios<CurationProperties>(
    `${url.fixtures}/${fixtureId}${url.curation_properties}`,
    {
      manual: !isOpen || !fixtureId,
    },
  );

  const handleCheckRecreation = (
    formData: {
      entityFormData: any;
      curationPropertiesFormData?: MetaPropertyFieldValue;
    },
    fixtureData: { startDate: string; name: string },
  ) => {
    if (formData.entityFormData) {
      const hoursDiff = getHoursDiff(formData.entityFormData.startDate, fixtureData.startDate);
      if (hoursDiff >= config.recreateEventTreshhold) {
        setMessage(
          strings.hours_rule
            .replace('{0}', hoursDiff.toString())
            .replace('{1}', config.recreateEventTreshhold.toString())
            .replace('{2}', fixtureData.name),
        );
        onShow();
        return;
      }
    }
    onFormSubmit(formData, { isRecreating: false });
  };

  return {
    config,
    isConfigLoading,
    recreateDialog: (
      <FixtureRecreateDialog
        message={message}
        onSubmit={onHide}
        open={isOpen}
        onClose={onHide}
        curationPropertiesData={curationPropertiesData}
      />
    ),
    onCheckRecreation: handleCheckRecreation,
  };
};
